import { Category } from "@/types/category";
import { ChartLine, Shield, Users, Rocket, Vote, Coins, Globe, Cpu } from "lucide-react";

export const categories: Category[] = [
  { name: "Analytics and Transparency Tools", icon: ChartLine, color: "bg-blue-500" },
  { name: "Enhanced User Protection", icon: Shield, color: "bg-green-500" },
  { name: "Social and Gamification Elements", icon: Users, color: "bg-purple-500" },
  { name: "Dynamic Token Launch Features", icon: Rocket, color: "bg-orange-500" },
  { name: "Advanced Governance and Community Features", icon: Vote, color: "bg-pink-500" },
  { name: "Advanced Token Mechanics", icon: Coins, color: "bg-yellow-500" },
  { name: "Interoperability and Ecosystem Expansion", icon: Globe, color: "bg-indigo-500" },
  { name: "Platform-Level Enhancements", icon: Cpu, color: "bg-cyan-500" }
];